export default "__VITE_ASSET__a2c75dc8__"